import React from 'react';
import './MenuPopupTeam.scss';
import './MenuPopupTeam-media.scss';
import { MenuTeamList, SvgDzen, SvgTg, SvgVk, SvgYoutube } from './constants';
import { ClosedSubMenuComponent } from '../../../services/GlobalFunctions';
import LinkHashMenu from '../LinkHashMenu/LinkHashMenu';
import LinkMenu from '../LinkMenu/LinkMenu';
import { LinkDzen, LinkTg, LinkVk, LinkYoutube } from '../../../services/content/Constants';
import { Props } from './interfaces';
import MenuGroup from '../MenuGroup/MenuGroup';

const MenuPopupTeam = ({ onClickLink, contactsData }: Props) => {
  // Build menu list from contactsData or fallback to hardcoded
  const menuList: any[] = [];

  if (contactsData && contactsData.children) {
    // Flatten children array (it's a 2D array)
    contactsData.children.flat()
      .filter((item: any) => item && item.title && item.url)
      .forEach((item: any) => {
        menuList.push({
          text: item.title,
          link: item.url,
          hash: false,
          children: item.children
        });
      });
  }

  // Fallback to hardcoded if no data
  const finalMenuList = menuList.length > 0 ? menuList : MenuTeamList;

  return (
    <div className="menu-popup-team">
      <div className="menu-popup-team__content">
        <div className="menu-popup-team__top">
          {finalMenuList.map((menu, i) => menu.children?.length ? (
            <div className="menu-popup-team__link" key={i}>
              <MenuGroup
                item={{ title: menu.text, url: menu.link, children: menu.children }}
                onClickLink={() => {
                  ClosedSubMenuComponent();
                  onClickLink && onClickLink();
                }}
              />
            </div>
          ) : (
            <div className="menu-popup-team__link" onClick={ClosedSubMenuComponent} key={i}>
              {menu.hash ? (
                <LinkHashMenu menu={menu} onClickLink={onClickLink} />
              ) : (
                <LinkMenu menu={menu} onClickLink={onClickLink} />
              )}
            </div>
          ))}
        </div>

        <div className="menu-popup-team__socs">
          <a href={LinkTg} className="menu-popup-team__soc" target="_blank" rel="nofollow">
            {SvgTg}
          </a>
          <a href={LinkVk} className="menu-popup-team__soc" target="_blank" rel="nofollow">
            {SvgVk}
          </a>
          <a href={LinkYoutube} className="menu-popup-team__soc" target="_blank" rel="nofollow">
            {SvgYoutube}
          </a>
          <a href={LinkDzen} className="menu-popup-team__soc" target="_blank" rel="nofollow">
            {SvgDzen}
          </a>
        </div>
      </div>
    </div>
  );
};

export default MenuPopupTeam;
